export const ACCESS_TOKEN = "access"
export const REFRESH_TOKEN = "refresh"

